var BufferListChildView = require('bufferlistchildview');


var BufferListConversationView = BufferListChildView.extend({
    className: BufferListChildView.prototype.className + ' conversation',

    render: function () {
        BufferListChildView.prototype.render.call(this);
        
        this.listenTo(this.model.recipient, 'change:nick', this.renderLinkText);
        this.listenTo(this.model.recipient, 'change:display_name', this.renderLinkText);
        this.listenTo(this.model.session.pinnedBuffers, 'recipientChange', this.renderLinkText);
        
        return this;
    }
});


module.exports = BufferListConversationView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistconversationview.js
// module id = xUgn
// module chunks = 1